import { ref } from 'vue'

let idCounter = 0

export function useUniqueId(prefix = 'form') {
  const id = ref(`${prefix}-${++idCounter}`)
  return id
}
